<template>
  <div class="BillingDetails">
    <el-card class="box-card" v-loading="is_billing_details_loading">
      <el-collapse v-model="billing_details_collapse" accordion>
        <el-collapse-item name="1">
          <template slot="title">
            <div class="flex">
              <img
                src="../assets/images/myAccount/payments.png"
                style="width: 16px;"
              />
              <div
                class="label-md-bold-black left-margin-10"
                style="color: #2d2e8d;"
              >
                Billing Details
              </div>
            </div>
          </template>
          <div style="padding: 0 20px;">
            <el-row :gutter="15">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': billing_name.length,
                    'form-group--error': $v.billing_name.$error,
                  }"
                >
                  <label class="input-label-bold-gray">Billing name</label
                  >&nbsp;<span class="required-field">*</span>
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="Company name"
                    v-model="billing_name"
                    @input="setBillingName($event.target.value)"
                  />
                </div>

                <div
                  style="color:red; font-size: 0.75em;"
                  v-if="validate_billing_name"
                >
                  Please enter alphabetic characters only
                </div>
                <div class="error" v-if="!$v.billing_name.required">
                  Field is required
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="15" class="top-margin-15">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="form-group">
                  <label class="input-label-bold-gray">GST number</label>
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="GST number"
                    v-model="gst_number"
                    @input="setGstNo($event.target.value)"
                  />
                </div>
                <div
                  style="color:red; font-size: 0.75em;"
                  v-if="gst_number_error"
                >
                  GST number must be alpha numeric and exactly 15 digits
                </div>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="form-group">
                  <label class="input-label-bold-gray">PAN number</label>
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="PAN number"
                    v-model="pan_number"
                    @input="setPanNo($event.target.value)"
                  />
                </div>
                <div
                  style="color:red; font-size: 0.75em;"
                  v-if="pan_number_error"
                >
                  PAN number must be alpha numeric and exactly 10 digits
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="15" class="top-margin-10">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': address_line.length,
                    'form-group--error': $v.address_line.$error,
                  }"
                >
                  <label class="input-label-bold-gray">Address line</label
                  >&nbsp;<span class="required-field">*</span>
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="Address line"
                    v-model="address_line"
                    @input="setAddress($event.target.value)"
                  />
                </div>

                <div
                  style="color:red; font-size: 0.75em;"
                  v-if="validate_address_line"
                >
                  Please enter alphabetic characters only
                </div>
                <div class="error" v-if="!$v.address_line.required">
                  Field is required
                </div>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': city.length,
                    'form-group--error': $v.city.$error,
                  }"
                >
                  <label class="input-label-bold-gray">City</label>&nbsp;<span
                    class="required-field"
                    >*</span
                  >
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="City"
                    v-model="city"
                    @input="setCity($event.target.value)"
                  />
                </div>

                <div style="color:red; font-size: 0.75em;" v-if="validate_city">
                  Please enter alphabetic characters only
                </div>
                <div class="error" v-if="!$v.city.required">
                  Field is required
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="15" class="top-margin-10">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': state.length,
                    'form-group--error': $v.state.$error,
                  }"
                >
                  <label class="input-label-bold-gray">State</label>&nbsp;<span
                    class="required-field"
                    >*</span
                  >
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="State"
                    v-model="state"
                    @input="setState($event.target.value)"
                  />
                </div>

                <div
                  style="color:red; font-size: 0.75em;"
                  v-if="validate_state"
                >
                  Please enter alphabetic characters only
                </div>
                <div class="error" v-if="!$v.state.required">
                  Field is required
                </div>
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': zip_code.length,
                    'form-group--error': $v.zip_code.$error,
                  }"
                >
                  <label class="input-label-bold-gray">ZIP code</label
                  >&nbsp;<span class="required-field">*</span>
                  <input
                    type="text"
                    class="custom-input"
                    placeholder="ZIP code"
                    v-model="zip_code"
                    @input="setZipCode($event.target.value)"
                  />
                </div>

                <div
                  style="color:red; font-size: 0.75em;"
                  v-if="validate_zip_code"
                >
                  Please enter 6 digits only
                </div>
                <div class="error" v-if="!$v.zip_code.required">
                  Field is required
                </div>
              </el-col>
            </el-row>

            <div class="text-right save-btn-section top-margin-20">
              <el-button
                type="primary custom-btn"
                :loading="is_billing_details_save_progress"
                @click="saveBilingDetails()"
                >Save</el-button
              >
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </div>
</template>

<script>
import {
  serverAddr,
  serverAddrToUploadMediaFiles,
  serverHostName,
} from "../networkConfig";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import { EventBus } from "../eventBus";
import CripNotice from "crip-vue-notice";

export default {
  name: "BillingDetails",
  data() {
    return {
      billing_details_collapse: 1,
      billing_name: "",
      validate_billing_name: false,
      gst_number: "",
      gst_number_error: false,
      pan_number: "",
      pan_number_error: false,
      address_line: "",
      validate_address_line: false,
      city: "",
      validate_city: false,
      state: "",
      validate_state: false,
      zip_code: "",
      validate_zip_code: false,
      is_billing_details_save_progress: false,
      is_billing_details_loading: false,
    };
  },

  validations: {
    billing_name: {
      required,
    },
    address_line: {
      required,
    },
    city: {
      required,
    },
    state: {
      required,
    },
    zip_code: {
      required,
    },
  },

  mounted() {
    // checked if object stored in store then retrieved it
    if (Object.keys(this.getBillingDetails).length) {
      this.billing_name = this.getBillingDetails.billing_name;
      this.gst_number = this.getBillingDetails.gst_number;
      this.pan_number = this.getBillingDetails.pan_number;
      this.address_line = this.getBillingDetails.address_line;
      this.city = this.getBillingDetails.city;
      this.state = this.getBillingDetails.state;
      this.zip_code = this.getBillingDetails.zip_code;
    } else {
      // otherwise fetch detail from api
      this.getBillingDetailsNetworkCallBack();
    }
  },

  methods: {
    setBillingName(value) {
      if (value) {
        // this.billing_name = value.trim();
        this.$v.billing_name.$touch();
        var letters = /^[a-zA-Z0-9_ .,]+$/;
        if (this.billing_name.match(letters)) {
          this.validate_billing_name = false;
        } else if (this.billing_name != "") {
          this.validate_billing_name = true;
        }
      }
    },

    setAddress(value) {
      if (value.trim()) {
        // this.address_line = value.trim();
        this.$v.address_line.$touch();
        var letters = /^[a-zA-Z0-9_ .,/#&+-]+$/;
        if (this.address_line.match(letters)) {
          this.validate_address_line = false;
        } else if (this.address_line != "") {
          this.validate_address_line = true;
        }
      } else {
        this.validate_address_line = true;
      }
    },

    setPanNo(newNumber) {
      if (newNumber) {
        this.pan_number_error = true;
        let regex = /^([a-zA-Z0-9]{10,10})$/; //regex to validate string for aplha numeric 10 character string
        if (regex.test(newNumber)) {
          this.pan_number_error = false;
        } else {
          this.pan_number_error = true;
        }
      } else {
        this.pan_number_error = false;
      }
    },

    setGstNo(newNumber) {
      if (newNumber) {
        this.gst_number_error = true;
        let regex = /^([a-zA-Z0-9]{15,15})$/; //regex to validate string for aplha numeric 15 character string
        if (regex.test(newNumber)) {
          this.gst_number_error = false;
        } else {
          this.gst_number_error = true;
        }
      } else {
        this.gst_number_error = false;
      }
    },

    setCity(value) {
      if (value.trim()) {
        // this.city = value.trim();
        this.$v.city.$touch();
        var letters = /^[A-Za-z_ ]+$/;
        if (this.city.match(letters)) {
          this.validate_city = false;
        } else if (this.city != "") {
          this.validate_city = true;
        }
      } else {
        this.validate_city = true;
      }
    },

    setState(value) {
      if (value) {
        // this.state = value.trim();
        this.$v.state.$touch();
        var letters = /^[A-Za-z]+$/;
        if (this.state.match(letters)) {
          this.validate_state = false;
        } else if (this.state != "") {
          this.validate_state = true;
        }
      }
    },

    setZipCode(value) {
      if (value) {
        this.zip_code = value.trim();
        this.$v.zip_code.$touch();
        var letters = /^([0-9]{6,6})$/;
        if (this.zip_code.match(letters)) {
          this.validate_zip_code = false;
        } else if (this.zip_code != "") {
          this.validate_zip_code = true;
        }
      }
    },

    saveBilingDetails() {
      if (
        this.billing_name.trim() &&
        !this.validate_billing_name &&
        (this.address_line.trim() && !this.validate_address_line) &&
        (this.city.trim() && !this.validate_city) &&
        (this.state.trim() && !this.validate_state) &&
        (this.zip_code.trim() && !this.validate_zip_code) &&
        !this.pan_number_error &&
        !this.gst_number_error
      ) {
        this.save();
      } else {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: "Please fill all details",
          type: "error",
          duration: 3,
        });
      }
    },

    // api to sav billing details
    save() {
      this.is_billing_details_save_progress = true; //enabled loader
      serverAddr
        .post("/stockants_pro/create_billing_details/", {
          name: this.billing_name,
          gst_number: this.gst_number,
          pan_number: this.pan_number,
          address: this.address_line,
          city: this.city,
          state: this.state,
          zip_code: this.zip_code,
        })
        .then((response) => {
          if (response.data.status) {
            // store billing details in store
            let obj = {
              billing_name: this.billing_name,
              gst_number: this.gst_number,
              pan_number: this.pan_number,
              address_line: this.address_line,
              city: this.city,
              state: this.state,
              zip_code: this.zip_code,
            };

            new CripNotice({
              title: "Success",
              description: "Updated billing details",
              type: "success",
              duration: 3,
            });

            this.$store.commit("commitBillingDetails", obj);
          }
          this.is_billing_details_save_progress = false; //disabled loader
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_billing_details_save_progress = false; //disabled loader
          }.bind(this)
        );
    },

    getBillingDetailsNetworkCallBack() {
      this.is_billing_details_loading = true; //enabled loader
      serverAddr
        .get("/stockants_pro/create_billing_details/")
        .then((response) => {
          if (response.data.status) {
            let billing_details = response.data.data;
            // store billing details in store
            let obj = {
              billing_name: billing_details.name,
              gst_number: billing_details.gst_number,
              pan_number: billing_details.pan_number,
              address_line: billing_details.address,
              city: billing_details.city,
              state: billing_details.state,
              zip_code: billing_details.zip_code,
            };

            this.billing_name = billing_details.name;
            this.gst_number = billing_details.gst_number;
            this.pan_number = billing_details.pan_number;
            this.address_line = billing_details.address;
            this.city = billing_details.city;
            this.state = billing_details.state;
            this.zip_code = billing_details.zip_code;

            this.$store.commit("commitBillingDetails", obj);
          }
          this.is_billing_details_loading = false; //disabled loader
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_billing_details_loading = false; //disabled loader
          }.bind(this)
        );
    },
  },

  computed: {
    getBillingDetails() {
      return this.$store.state.billing_details;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";
.BillingDetails {
  .el-button--primary.is-disabled {
    color: #fff;
    background-color: #a0cfff;
    border-color: #a0cfff;
  }
  .el-button--primary.is-disabled {
    color: #fff;
    background-color: #a0cfff;
    border-color: #a0cfff;
  }
}
</style>
